import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const ManageUserPage = lazy(() => import("./pages/ManageUserPage"));
const RolesPermissionsPage = lazy(() => import("./pages/RolesPermissionsPage"));
const UserListPage = lazy(() => import("./pages/UserListPage"));

export const userManagementRoutes = [
  {
    path: PATHS.USER_LIST,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.USER_MANAGEMENT}>
        <UserListPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "user_list", action: "view" } },
  },
  {
    path: `${PATHS.MANAGE_USER}/:userId`,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.USER_MANAGEMENT}>
        <ManageUserPage />
      </FeatureProvider>
    ),
    handle: {
      permission: {
        required: ["user_list:update", "user_list:edit"],
        mode: "any",
      },
    },
  },
  {
    path: PATHS.ROLES_PERMISSIONS,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.USER_MANAGEMENT}>
        <RolesPermissionsPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "roles_permissions", action: "view" } },
  },
];
